import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=5f077e96&"
import script from "./Notices.vue?vue&type=script&lang=js&"
export * from "./Notices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports